import React, { useState, useEffect } from "react";
import { FaStar } from "react-icons/fa";
import { getReview } from "../review/getreview";
import blank from "../assets/blank-avatar.png";
import "./reviewcomment.css";

const ReviewComment = () => {
  const [review, setReview] = useState([]);

  useEffect(() => {
    getReview()
      .then(response => {
        setReview(response.data.results);
      })
      .catch(error => {
        console.log(error);
      });
  }, []);
  console.log("ambit data review", review);

  return (
    <div className="comment-container">
      <div className="update-comments">
        {review.map(item => (
          <div className="review-comments" key={item._id}>
            <div className="review-image">
              <img
                src={
                  /* item.user_id.profile_pic ? `https://moviesteamd.herokuapp.com/${item.user_id.profile_pic}` :*/ blank
                }
                alt=""
                width="50"
                height="50"
              />
            </div>
            <div className="column-items">
              {/* <div className="user">{item.user_id.userName}</div> */}
              <p>
                <FaStar size={15} color="#ffc107" />
                {" " + item.score + "/10"}
              </p>
              <p className="comments">{item.review_headline}</p>
              <p className="created">date : {item.createdAt.slice(0, 10)}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewComment;
